import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { IosInstallCode } from '@/models/codes/codes.model';

export interface CodesUseCases {
  getAppUrl(store: string): Observable<IosInstallCode>;
}

export const CODES_USE_CASES = new InjectionToken<CodesUseCases>('CODES_USE_CASES');
